module.exports = __webpack_public_path__ + "static/media/galerija_2017 (12).8c331110.jpg";